export default function PHP_output_reset_rewrite_vars() {
  return (
    <div>
      <h1>PHP_output_reset_rewrite_vars</h1>
    </div>
  );
}
